export { default } from './NewsPage';
